import type { ReactNode } from 'react';

import { Mascot } from './Mascot';

/**
 * 진단 흐름이 잠깐 멈추고 **말만 하는 화면**의 공통 껍데기 — 주변 소음(`884:9858`),
 * 단계 완료(`884:9451`), 전체 완료(`893:13968`)가 시안에서 같은 레이아웃이다.
 *
 * 셋이 각자 그리면 제목 자간이나 캡슐 색을 시안이 바꾸는 날 세 파일을 따로 고쳐야 하고,
 * 그 중 하나를 빠뜨리면 같은 흐름 안에서 화면마다 글자가 다르게 앉는다.
 *
 * 마스코트는 **언제나** 있다 — 세 화면 다 그 자리에 그림이 있고, 없는 변형이 시안에 없다.
 * 그림이 빠질 화면이 생기면 그때 옵션으로 연다(지금 열어 두면 아무도 안 쓰는 분기가 된다).
 */

export const FullScreenNotice = ({
  title,
  banner,
  children,
  footer,
}: {
  /** 제목. 줄바꿈(`\n`)은 시안의 줄 나눔 그대로 살린다. */
  title: string;
  /** 분홍 테두리 캡슐 한 줄 — 무엇을 하면 되는지. */
  banner: string;
  /** 캡슐과 마스코트 사이. 단계 완료의 측정 요약처럼 화면마다 다른 것만 넣는다. */
  children?: ReactNode;
  /** 하단 버튼들. 화면마다 개수와 배치가 달라 통째로 받는다. */
  footer: ReactNode;
}) => (
  <div className="flex flex-1 flex-col items-center px-5 pb-8">
    <h2 className="mt-20 whitespace-pre-line text-center text-[22px] font-semibold leading-[1.5] tracking-[-0.11px] text-[hsl(var(--title))]">
      {title}
    </h2>

    <p className="mt-6 whitespace-pre-line rounded-2xl border border-primary/20 bg-primary/[0.03] px-5 py-4 text-center text-sm font-medium leading-[1.6] text-foreground">
      {banner}
    </p>

    {children}

    <Mascot className="mt-10 w-[180px]" />

    <div className="mt-auto flex w-full gap-3 pt-8">{footer}</div>
  </div>
);
